import React, { useCallback, useState } from 'react'
import {
  Alert,
  Button,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { useFieldArray, UseFormReturn, useWatch } from 'react-hook-form'

import { FormOperacionLCTC } from '../types/types'
import { OperacionLCTCCuentaFields, OperacionLCTCFields, OperacionLCTCRelacionFields } from '../types/fields'
import CardActions from 'src/pages/sistema/components/CardActions'
import { OperacionLCTCFilaCuenta } from './OperacionLCTCFilaCuenta'
import { OperacionLCTCRelacion } from '../types/dto'
import { useLCTCRelacionTipos } from '../hooks/useLCTCCache'
import { AddCircleOutline } from '@mui/icons-material'
import { OperacionLCLSRelacionFields } from '../../lcls/types/fields'

interface SeccionNuevoLCTCCuentasProps {
  formMethods: UseFormReturn<FormOperacionLCTC>
}

export const SeccionNuevoLCTCCuentas = ({ formMethods }: SeccionNuevoLCTCCuentasProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { control, getValues } = formMethods;
  const { fields, append, remove } = useFieldArray({
    control: formMethods.control,
    name: OperacionLCTCFields.Cuentas
  });

  const watchedSectorComercial = useWatch({
    control,
    name: OperacionLCTCFields.CodSectorComercial
  });

  const { relaciones, isLoading } = useLCTCRelacionTipos(watchedSectorComercial);


  const handleAgregarCuenta = (relacion: OperacionLCTCRelacion) => {
    append({
      [OperacionLCTCCuentaFields.CodClienteTipo]: relacion[OperacionLCTCRelacionFields.CodClienteTipo],
      [OperacionLCTCCuentaFields.DescClienteTipo]: relacion[OperacionLCTCRelacionFields.DescClienteTipo],
      [OperacionLCTCCuentaFields.CodClienteSubTipo]: relacion[OperacionLCTCRelacionFields.CodClienteSubTipo],
      [OperacionLCTCCuentaFields.DescClienteSubTipo]: relacion[OperacionLCTCRelacionFields.DescClienteSubTipo],

      [OperacionLCTCCuentaFields.LimiteConcertacion]: null as any,
    });
    handleCloseMenu();
  };

  const handleOpenMenu = useCallback((event: React.MouseEvent<HTMLElement>) => {
    if (relaciones.length === 0) {
      return;
    }
    if (relaciones.length > 1) {
      setAnchorEl(event.currentTarget);

    }
    else {
      handleAgregarCuenta(relaciones[0]);
    }
  }, [relaciones]);
  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <CardActions title={'Cuentas'} icon='mdi:account-cash-outline' colapsable

      // actions={
      //   <>
      //     <Button startIcon={<AddCircleOutline />} variant="contained" onClick={handleOpenMenu}
      //       disabled={!relaciones || isLoading || relaciones.length === 0}
      //     >
      //       Agregar Cuenta
      //     </Button>
      //     <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
      //       {relaciones.map((rel, index) => (
      //         <MenuItem key={index} onClick={() => handleAgregarCuenta(rel)}>
      //           {rel[OperacionLCLSRelacionFields.DescClienteTipo]} - {rel[OperacionLCLSRelacionFields.DescClienteSubTipo]}
      //         </MenuItem>
      //       ))}
      //     </Menu>
      //   </>
      // }
    >
      {fields.length === 0 ? (
        <Alert severity='info'>Seleccione una Unidad de Negocio para ver las cuentas.</Alert>
      ) : (
        <TableContainer component={Paper}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell><Typography variant="body2">Tipo Cliente</Typography></TableCell>
                <TableCell><Typography variant="body2">Sub-tipo</Typography></TableCell>
                <TableCell><Typography variant="body2">Límite de concertación (% del AUM)</Typography></TableCell>
                {/* <TableCell><Typography variant="body2">Límite de liquidación DVP</Typography></TableCell>
                                <TableCell><Typography variant="body2">Límite de liquidación FOP</Typography></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {fields.map((field, index) => (
                <OperacionLCTCFilaCuenta key={field.id} formMethods={formMethods} index={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </CardActions>
  )
}